import nlMessages from "../locales/nl_NL";

const NlLang = {
  messages: {
    ...nlMessages,
  },
  locale: "nl-NL",
};
export default NlLang;
